/* taitiy-cat-pjax.js — 复刻 2020「秒加载破解版」主题的站内 Catalog 秒切页
 * 库：defunkt/jquery-pjax（与 2020 破解主题同款），仅做容器交换 + 历史记录。
 *
 * 相对上一代“现代”方案的两处修正 + 本轮针对「骨架屏闪回 / Cloudflare 验证」的修正：
 *   1) 悬停/进入视口即【预取】目标页 HTML（2020 未做，但本店类目页 600KB+，不预取则每次
 *      点击都要实时拉整页）。——但上一代的「IntersectionObserver 批量预取 + hover 预取」会在
 *      一次页面加载里瞬间打出 30~40 个整页 HTML 请求，被 Cloudflare 当成爬虫直接弹验证。
 *      ★本轮：预取只在「按下意图(pointerdown)」时触发（鼠标+触摸通用），且并发上限 1，
 *        并把 jQuery 默认带上的 X-Requested-With: XMLHttpRequest（强 bot 信号）去掉。
 *        这样每次导航最多 1 个预取请求，与正常浏览的请求量相当 → 不再触发 Cloudflare。
 *   2) 去掉 opacity:.55 的“半透明白”遮罩（上一代的“半白”就是它），改为顶部细进度条。
 *   3) 换页后正确【重绑】：派发 shopify:section:load 让 theme.Sections 重初始化，
 *      并清掉 Ajaxinate / facets 残留的 loading-overlay（否则换页后一直转圈）。
 *   4) 骨架屏：全局骨架只在「整页首次加载」有用；站内 PJAX 秒切时它反而闪回成累赘。
 *      因此在【第一次 PJAX 换页】时给 body 加 .taitiy-pjax-ready，并用 !important 永久隐藏
 *      全局骨架（不依赖它自身的 .taitiy-skeleton-loaded），彻底杜绝闪回；同时换页时立即
 *      隐藏新内容里的 .loading-overlay，避免“转圈/骨架”闪一下。
 *
 * 作用范围：覆盖 首页(/)、类目(/collections/)、搜索(/search)、页面(/pages/)、博客(/blogs/ 含文章)
 *   的站内链接，做平滑秒切；明确排除 产品 PDP(/products/)、/cart、/checkout、/account、
 *   target=_blank、修饰键点击、# 锚点、外部域、[data-no-swap] —— 这些由 jquery-pjax 内部放行，
 *   走正常整页导航（产品/账户页交互重，不秒换最稳）。
 * 关闭：URL 加 ?pjax=0 或 ?swup=0（关秒切），或 ?pjax=noprefetch（关预取但保留秒切）。
 *       localStorage.taitiy_no_pjax=1 / taitiy_no_prefetch=1 等价。
 */
(function () {
  'use strict';
  var $ = window.jQuery;
  if (!$) return;                       // 需要 jQuery（由 jquery.min.js 提供）

  var MAIN = '#MainContent';
  var cache = {};                       // url -> 整页 HTML 字符串（预取/历史）
  var pending = {};                     // url -> true（正在预取）
  var PREFETCH_CAP = 1;                 // 并发预取上限（控制对 Cloudflare 的请求量）
  var inflight = 0;
  var skeletonSuppressed = false;

  /* ---------- 关闭开关 ---------- */
  var qs = '';
  try { qs = location.search; } catch (e) {}
  try {
    if (/[?&](swup|pjax)=0\b/.test(qs) ||
        (window.localStorage && localStorage.getItem('taitiy_no_pjax'))) return;
  } catch (e) {}
  var PREFETCH_OFF = /[?&]pjax=noprefetch\b/.test(qs) ||
        (window.localStorage && localStorage.getItem('taitiy_no_prefetch'));

  /* ---------- 范围判定：哪些链接走站内秒切（其余由 jquery-pjax 内部放行→正常整页导航） ---------- */
  function isSwappableUrl(url) {
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;     // 外部域 → 不放行
      var p = u.pathname;
      // 硬性排除：产品详情页(PDP) 与 购物车/结账/账户 —— 交互重，整页导航最稳
      if (/^\/products\//.test(p)) return false;
      if (/^\/(cart|checkout|account)(\/|$)/.test(p)) return false;
      // 允许秒换：首页、类目、搜索、页面、博客(索引+文章)
      if (p === '/' || p === '') return true;                                  // 首页
      if (p.indexOf('/collections/') === 0) return true;                       // 类目
      if (p === '/search' || p.indexOf('/search/') === 0) return true;         // 搜索
      if (p.indexOf('/pages/') === 0) return true;                             // 页面
      if (p === '/blogs' || p.indexOf('/blogs/') === 0) return true;           // 博客(含文章)
      return false;
    } catch (e) { return false; }
  }

  /* ---------- 顶部细进度条（替代半透明白遮罩） ---------- */
  var bar;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'taitiy-pjax-bar';
    bar.style.cssText = 'position:fixed;top:0;left:0;height:3px;width:0;z-index:2147483647;' +
      'background:#E8A33D;transition:width .2s ease,opacity .3s ease;opacity:0;pointer-events:none;';
    document.body.appendChild(bar);
    return bar;
  }
  function showBar() { var b = ensureBar(); b.style.opacity = '1'; b.style.width = '35%'; }
  function endBar() { var b = ensureBar(); b.style.width = '100%'; setTimeout(function () { b.style.opacity = '0'; setTimeout(function () { b.style.width = '0'; }, 300); }, 120); }

  /* ---------- 骨架屏：PJAX 激活后永久隐藏全局骨架（防闪回） ---------- */
  function suppressSkeleton() {
    if (skeletonSuppressed) return;
    skeletonSuppressed = true;
    try { document.body.classList.add('taitiy-pjax-ready'); } catch (e) {}
    try {
      var s = document.createElement('style');
      s.setAttribute('data-taitiy-pjax', '1');
      s.textContent =
        'body.taitiy-pjax-ready .taitiy-global-skeleton{display:none!important;visibility:hidden!important;opacity:0!important;animation:none!important}' +
        'body.taitiy-pjax-ready #MainContent .loading-overlay{display:none!important;visibility:hidden!important}';
      document.head.appendChild(s);
      var sk = document.querySelector('.taitiy-global-skeleton');
      if (sk) sk.style.display = 'none';
    } catch (e) {}
  }

  /* ---------- 换页前后重绑（生死线，对应 2020 的 pjax:end 调度器） ---------- */
  function dispatchSections(name, root) {
    var main = root || $(MAIN)[0];
    if (!main) return;
    var els = main.querySelectorAll('[data-section-id]');
    for (var i = 0; i < els.length; i++) {
      try {
        els[i].dispatchEvent(new CustomEvent(name, {
          bubbles: true,
          detail: { sectionId: els[i].getAttribute('data-section-id') }
        }));
      } catch (e) {}
    }
  }
  function fireAnalytics() {
    try { if (window.gtag) window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search, page_location: location.href, page_title: document.title }); } catch (e) {}
    try { if (window.fbq) window.fbq('track', 'PageView'); } catch (e) {}
  }

  /* 把整页 HTML 换成 #MainContent 内容；返回是否成功 */
  function applyHtml(html, url) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var m = doc.querySelector(MAIN);
    if (!m || !m.innerHTML.trim()) return false;
    var main = $(MAIN)[0];
    if (!main) return false;
    // 先隐藏新内容里的 loading 遮罩，避免换页瞬间“转圈/骨架”闪一下
    try { var ov = m.querySelectorAll('.loading-overlay'); for (var k = 0; k < ov.length; k++) { ov[k].style.display = 'none'; } } catch (e) {}
    dispatchSections('shopify:section:unload', main);     // 清理旧实例
    main.innerHTML = m.innerHTML;                         // 只换主内容，header/footer 常驻
    dispatchSections('shopify:section:load', main);       // 重绑 theme.Sections / wishlist / compare / facets
    // 换页后清掉 Ajaxinate / facets 卡住的 loading 遮罩（否则一直转圈）
    try { $(main).find('.loading-overlay').css('display', 'none').removeClass('loading').addClass('hidden'); } catch (e) {}
    if (window.lazyLoadInstance && window.lazyLoadInstance.update) { try { window.lazyLoadInstance.update(); } catch (e) {} }
    if (doc.title) document.title = doc.title;
    fireAnalytics();
    window.scrollTo(0, 0);
    return true;
  }

  /* ---------- 预取：仅在“按下意图”(pointerdown) 且并发≤1（Cloudflare 安全） ----------
   * 去掉 jQuery 默认带上的 X-Requested-With: XMLHttpRequest（强 bot 信号），让预取请求
   * 看起来更像正常导航。命中后点击≈瞬时，且整段导航最多 1 个请求，与普通浏览相当。 */
  function stripBot(xhr) { try { xhr.setRequestHeader('X-Requested-With', ''); } catch (e) {} }
  function prefetch(url) {
    if (PREFETCH_OFF || !url || cache[url] || pending[url] || inflight >= PREFETCH_CAP) return;
    pending[url] = true; inflight++;
    $.ajax({ url: url, dataType: 'html', cache: true, timeout: 15000, beforeSend: stripBot })
      .done(function (html) { cache[url] = html; })
      .fail(function () { cache[url] = null; })
      .always(function () { delete pending[url]; inflight--; });
  }
  // pointerdown 覆盖鼠标左键 + 触摸 + 笔，是“即将点击”的最强意图信号
  $(document).on('pointerdown', 'a', function (e) {
    if (e.button !== undefined && e.button !== 0) return;
    var h = this.getAttribute('href');
    if (isSwappableUrl(h)) prefetch(this.href);
  });
  // （可选）桌面 hover 轻量预取：默认关闭，避免请求风暴。需要更“悬停即预载”手感时把下面两行注释去掉，
  // 它仍受 PREFETCH_CAP=1 限制（一次只预取 1 个）。
  // $(document).on('mouseenter', 'a', function () { var h = this.getAttribute('href'); if (isSwappableUrl(h)) prefetch(this.href); });

  /* ---------- 点击拦截：必须在 jquery-pjax 发请求前处理（用 pjax:click 钩子） ----------
   * pjax:click 在 jquery-pjax 真正发请求前同步触发，且尊重 preventDefault —— 这是
   * 预取命中时“瞬时换页”的关键：命中缓存就拦截，不让 jquery-pjax 再去拉网络。 */
  $(document).on('pjax:click', function (e) {
    suppressSkeleton();                       // 第一次换页即锁死全局骨架，杜绝闪回
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    var href = a ? a.href : '';                              // 用绝对地址，与预取缓存 key 一致
    if (!isSwappableUrl(href)) { e.preventDefault(); return; }   // 非可秒换 → 普通导航（不劫持 PDP/购物车等）
    // 预取正在路上 → 等它完成，避免 jquery-pjax 再发一次请求（Cloudflare 友好：每段导航最多 1 个请求）
    if (pending[href] && !cache[href]) {
      e.preventDefault();
      showBar();
      var waited = 0;
      var iv = setInterval(function () {
        waited++;
        if (cache[href] && cache[href] !== null) {
          clearInterval(iv);
          if (applyHtml(cache[href], href)) endBar(); else window.location.href = href;
        } else if (cache[href] === null || waited > 20) {     // 预取失败/超时 → 放行让 jquery-pjax 拉
          clearInterval(iv); endBar();
          try { $.pjax({ url: href, container: MAIN, fragment: MAIN, timeout: 15000, scrollTo: false, maxCacheLength: 20, beforeSend: stripBot }); }
          catch (err) { window.location.href = href; }
        }
      }, 80);
      return;
    }
    if (cache[href] && cache[href] !== null) {                // 命中预取缓存 → 瞬时换页
      e.preventDefault();
      showBar();
      if (applyHtml(cache[href], href)) { endBar(); }
      else { window.location.href = href; }
    }
    // 未命中 → 交给 jquery-pjax 正常拉取（pjax:send 显示进度条，pjax:end 重绑）
  });

  /* ---------- jquery-pjax：非预取点击的容器交换 + 历史（含前进/后退缓存） ---------- */
  $(document).pjax('a', MAIN, {
    fragment: MAIN,
    timeout: 15000,
    scrollTo: false,
    maxCacheLength: 20,
    beforeSend: stripBot                  // 同样去掉 X-Requested-With
  });
  $(document).on('pjax:send', function () { suppressSkeleton(); showBar(); });
  $(document).on('pjax:complete', function () { endBar(); });
  $(document).on('pjax:end', function (e, xhr, opts) {
    // jquery-pjax 已替换 #MainContent；这里补做本店专属重绑（遮罩清理 + lazyload + 骨架锁死）
    suppressSkeleton();
    var main = $(MAIN)[0];
    if (main) {
      try { $(main).find('.loading-overlay').css('display', 'none').removeClass('loading').addClass('hidden'); } catch (err) {}
      if (window.lazyLoadInstance && window.lazyLoadInstance.update) { try { window.lazyLoadInstance.update(); } catch (err) {} }
    }
  });
  // 前进/后退：非可秒换页(如 PDP/账户)时整页刷新，避免内容错位
  $(window).on('popstate', function () {
    var url = location.pathname + location.search;
    if (!isSwappableUrl(url)) window.location.reload();
  });

  $(function () { /* 首屏保留全局骨架；骨架抑制推迟到第一次 PJAX 换页时 */ });
})();
